import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { DataGridComponent } from "../../../Common/Components/data-grid/data-grid.component";
import { ApiService } from '../../../Services/api.service';
import { AuthService } from '../../../Services/auth.service';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';
import { ConfirmPopupComponent } from '../../../Common/Components/confirm-popup/confirm-popup.component';
import { NzDatePickerComponent, NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-edp-adr-mapping',
  standalone: true,
  imports: [CommonModule, NzButtonModule, DataGridComponent, NzDatePickerModule, NzModalModule, NzSelectModule, ReactiveFormsModule, FormsModule,
    ConfirmPopupComponent, NzInputModule, NzIconModule
  ],
  templateUrl: './edp-adr-mapping.component.html',
  styleUrl: './edp-adr-mapping.component.scss'
})
export class EdpAdrMappingComponent {
  @Input() catalogId: any;
  edpArNoList: any = [];
  edpArValue: any = [];
  validateValues: boolean = false;
  selectedIds = new Set<number>();
  cloneSelectedIds = new Set<number>();
  newEDPAssociations: any = [];
  edp_ar_list: any = [];
  org_edp_ar_list: any = [];
  showModal: boolean = false;
  DefaultExists: boolean = false;
  messageList: any = ["New EDP/AR Association Added SuccessFully", "EDP/AR Association Deleted SuccessFully", "New EDP/AR Association Updated SuccessFully"];
  edpColumns: any = [
    {
      field: 'edpArNo',
      header: '',
      type: "checkbox"
    },
    {
      field: 'edpArNo',
      header: 'EDP/AR #',
      compare: (a: any, b: any) => (a.edpArNo ?? "").localeCompare((b.edpArNo ?? ""))
    },
    {
      field: 'startDate',
      header: 'Start Date & Time',
      dateField: true,
      allowClear: true,
      dateString: true,
      compare: (a: any, b: any) => (a.startDate ?? "").localeCompare((b.startDate ?? ""))
    },
    {
      field: 'endDate',
      header: 'End Date & Time',
      dateField: true,
      allowClear: true,
      dateString: true,
      disabledPastDate: true,
      fromField: 'startDate',
      compare: (a: any, b: any) => (a.endDate ?? "").localeCompare((b.endDate ?? ""))
    }];
  dateRange: any;
  startDate: any;
  endDate: any;
  searchText: string = '';
  @ViewChild('endDatePicker', { static: false }) endDatePicker!: NzDatePickerComponent;
  @ViewChild(DataGridComponent) private dataGridComponent!: DataGridComponent;

  constructor(private apiService: ApiService, public authService: AuthService) { }

  ngOnInit(): void {
    if (this.authService.webAdm) {
      this.edpColumns.push({
        field: '',
        header: 'Action',
        icons: ['edit', 'delete'],
        type: 'icon',
        showIcons: true
      })
    }
    this.getAdpErAssociation();
  }

  searchCatalogEdpArNo(edpArNo: string) {
    if (edpArNo.length == 5 || edpArNo.length == 11) {
      this.apiService.getCatelogEdpArNoList(this.catalogId, edpArNo).subscribe(response => {
        if (response) {
          this.edpArNoList = response.data;
          this.addDefaultToArrayList();
        }
      })
    }
  }

  addDefaultToArrayList() {
    if (!this.DefaultExists && !this.edpArNoList.includes('DEFAULT')) {
      this.edpArNoList.unshift('DEFAULT');
    }
  }

  pushDefault() {
    if (!this.edpArValue.includes('DEFAULT'))
      this.edpArValue = [...this.edpArValue, 'DEFAULT'];
    if (this.edpArNoList.length == 0) {
      this.edpArNoList.unshift('DEFAULT');
    }
  }

  closeSelect(selectComponent: NzSelectComponent) {
    selectComponent.nzOpen = false;
  }

  resetForm() {
    if (this.cloneSelectedIds.size == 0) {
      this.selectedIds = new Set<number>();
    }
    this.edpArValue = [];
    this.startDate = '';
    this.endDate = '';
    this.newEDPAssociations = [];

  }


  updateAssociation() {
    if (!this.authService.webAdm)
      return;

    if (this.edpArValue.length == 0) {
      this.validateValues = true;
      return;
    }
    if (this.endDate < this.startDate) {
      this.apiService.createNotification('error', 'To Date Should be greater than From Date');
      return;
    }

    if (this.endDate < this.startDate) {
      this.apiService.createNotification('error', 'To Date Should be greater than From Date');
      return;
    }
    this.validateValues = false;
    this.edpArValue.map((node: any) => {
      this.newEDPAssociations.push({ "catid": this.catalogId, "custaredp": node.includes('Default') ? 'DEFAULT' : node, "startDate": this.startDate, "endDate": this.endDate, "updateType": 'ADD' });
    });
    this.updateEDPARAssociationAPI(this.newEDPAssociations, this.messageList[0]);
  }

  disabledDate = (current: Date): boolean => {
    if (!this.startDate) { return false; }
    const start = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate()).getTime();
    const currnt = new Date(current.getFullYear(), current.getMonth(), current.getDate()).getTime();
    return currnt < start;
  };

  disablePastDates = (current: Date): boolean => {
    // Disable dates before today
    return current < new Date(new Date().setHours(0, 0, 0, 0));
  };

  openEndPicker() {
    this.endDatePicker.nzDisabled = false;
  }

  getAdpErAssociation() {
    this.apiService.getCatalogAssociatedEdpArList(this.catalogId).subscribe(response => {
      response = response;
      if (response && response.length > 0) {
        this.DefaultExists = false;
        let edp_ar_list_resp = response instanceof Array ? response : [];
        this.edp_ar_list = [];
        this.org_edp_ar_list = [];
        edp_ar_list_resp.forEach((node: any) => {
          let nodeName = node.edpArNo == 'DEFAULT' ? 'Default Site Catalog' : node.edpArNo;
          if (node.edpArNo == 'DEFAULT') {
            this.DefaultExists = true;
          }
          this.edp_ar_list.push({ edpArNo: nodeName, startDate: node.startDate, endDate: node.endDate });
          this.org_edp_ar_list.push({ edpArNo: nodeName, startDate: node.startDate, endDate: node.endDate })
        });
        this.addDefaultToArrayList();
      }
    });
  }

  updateEDPARAssociationAPI(data: any, message: string) {
    this.apiService.updateCatalogEdpArList(data).subscribe(response => {
      if (response) {
        this.resetForm();
        this.apiService.createNotification('success', message);
        this.edp_ar_list = [];
        this.getAdpErAssociation();
      }
    }, err => {
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

  selectedRows(selectedIds: any) {
    this.selectedIds = selectedIds;
    this.cloneSelectedIds = selectedIds;
  }

  deleteRow(data: any) {
    if (!this.authService.webAdm)
      return;

    this.prepareDeleteData([data.edpArNo]);
  }

  prepareDeleteData(deleteList: any) {
    let deleteEDPAssociationList: any = deleteList;
    if (deleteEDPAssociationList.length > 0) {
      deleteEDPAssociationList = deleteEDPAssociationList.map((node: any) => {
        return node == 'Default Site Catalog' ? 'DEFAULT' : node;
      });
      deleteEDPAssociationList.map((node: any) => {
        this.newEDPAssociations.push({ "catid": this.catalogId, "custaredp": node, "updateType": 'DELETE' });
      });
      this.updateEDPARAssociationAPI(this.newEDPAssociations, this.messageList[1]);
    }
  }

  updateRow(data: any) {
    if (!this.authService.webAdm)
      return;

    if (data.startDate && data.endDate) {
      if (new Date(data.endDate) < new Date(data.startDate)) {
        this.apiService.createNotification('error', 'To Date Should be greater than From Date');
       this.edp_ar_list = JSON.parse(JSON.stringify(this.org_edp_ar_list));
        return;
      }

      if (new Date(data.endDate) < new Date(data.startDate)) {
        this.apiService.createNotification('error', 'To Date Should be greater than From Date');
        this.edp_ar_list = JSON.parse(JSON.stringify(this.org_edp_ar_list));
        return;
      }
    }
    let post = [{ "catid": this.catalogId, "custaredp": data.edpArNo.includes('Default') ? 'DEFAULT' : data.edpArNo, "startDate": data.startDate, "endDate": data.endDate, "updateType": 'UPDATE' }]
    this.updateEDPARAssociationAPI(post, this.messageList[2]);
  }

  deAssociate() {
    if (!this.authService.webAdm)
      return;

    this.showModal = true;
  }

  onDeleteConfirm(): void {
    this.showModal = false;
    const deleteList = [...this.selectedIds];
    this.prepareDeleteData(deleteList);
  }

  onDeleteCancel(): void {
    this.showModal = false;
  }

  searchValue(searchValue: string, searchField: string) {
    this.dataGridComponent.searchData(searchValue, searchField);
  }

}
